import Checkbox from 'components/Checkbox';
import { useMemo } from 'react';

type ISettingTypeCheckBoxProps = {
  value?: string;
  onChange?: (value: string) => void;
  key?: string;
  baseKey?: string;
};

const SettingTypeCheckBox = ({ value, onChange, baseKey }: ISettingTypeCheckBoxProps) => {
  const isSelected = useMemo(() => {
    return value === baseKey;
  }, [value, baseKey]);

  return <Checkbox value={isSelected} onChange={() => onChange?.(baseKey || '')} size='large' />;
};

export default SettingTypeCheckBox;
